import { IDataConverter } from '@adex/shared/models/data-converter'
import { Injectable } from '@angular/core'


@Injectable({ providedIn: 'any' })
export class StubConverter<T> implements IDataConverter<T, T> {
  public toInside(data: T): T {
    return data
  }

  public toOutside(data: T): T {
    return data
  }

}
